import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "asLesson_col" }
const _hoisted_2 = { class: "asLesson_title" }
const _hoisted_3 = { class: "asLesson_subtitle" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "asLesson_delay" }, null, -1)
const _hoisted_5 = { class: "asLesson_col" }
const _hoisted_6 = { class: "asLesson_time" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "asLesson_more" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "asLesson",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.lesson.lesson.title), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.lesson.lesson.subtitle), 1),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.time(_ctx.lesson.video.duration)), 1),
      _hoisted_7
    ])
  ]))
}